const i18nPrefix = 'RichTextLib.embed.';
export const i18nKey = key => `${i18nPrefix}${key}`;
export const i18nAlignmentKey = key => `${i18nPrefix}alignment.${key}`;
export const i18nSizeKey = key => `${i18nPrefix}size.${key}`;
const scriptRegex = /<script[\s\S]*?>[\s\S]*?<\/script>/;

// Checks for the presence of a script tag in the html
export const checkForEmbedScripts = (html = '') => scriptRegex.test(html);